import types from '../constants/actionTypes';

const location = (state, action) => {
  switch (action.type) {
    case types.location.LOCATION_CHANGE_COMPLETE:
      state = state.merge({
        name: action.route.name,
        options: action.route.options,
      });
      break;
    case types.location.LOCATION_REQUEST:
      state = state.merge({
        request: {
          pathname: action.path,
          search: '',
        },
      });
      break;
    case types.location.LOCATION_REQUEST_CLEAR:
      state = state.merge({
        request: {
          pathname: '',
          search: '',
        },
      });
      break;
    case types.location.LOCATION_REQUEST_CLEAR:
      state = state.updateIn(['options'], () => { search: '' });
      break;
  }
  return state;
};

const destructParams = (path) => {
  if (!path) {
    return {};
  }

  let obj = {};
  path.match(/[(\?|\&)]([^=]+)\=([^&#]+)/g)
      .map(function (match) { return match.match(/[(\?|\&)]([^=]+)\=([^&#]+)/); })
      .map(function (match) { Object.assign(obj, { [match[1]]: match[2] }) });
  return obj;
};

export default location;



/** WEBPACK FOOTER **
 ** ./reducers/location.js
 **/